export const CLIENTTYPE_SHOW_RESET = 'CLIENTTYPE_SHOW_RESET'
export const CLIENTTYPE_SHOW_SET_ERROR = 'CLIENTTYPE_SHOW_SET_ERROR'
export const CLIENTTYPE_SHOW_SET_RETRIEVED = 'CLIENTTYPE_SHOW_SET_RETRIEVED'
export const CLIENTTYPE_SHOW_TOGGLE_LOADING = 'CLIENTTYPE_SHOW_TOGGLE_LOADING'
